import Vue from 'vue';
import { Checkbox } from 'element-ui';

/**
 * 此marco提供一组更详细的文本设定方案,允许通过配置方式改善原来body的默认黑色文本  
 * 下面的配置选项择一传入即可  
 * renderer: 通过渲染函数渲染,分别指定文本和颜色
 * map: 通过主属性渲染,运行时根据prop向行数据索要对应值,再根据map匹配,default可为缺省配置
 * template: 通过模版渲染,采用模板字符串语法,类似el-table,可以引用的上下文有$index,column,row变量.不支持color
 */
interface opt {
    renderer: (row) => { color: string, text: string },
    template: string,
    map: Record<string, { color: string, text: string }>
}

export function macroEnhancedText(vm: Vue, h: any) {
    const scopedSlots = {
        default: function (body) {
            const desc = body.desc;

            if (desc.renderer) {
                let { color, text } = desc.renderer(body.row);

                return <span style={color ? 'color:' + color : ''}>{text}</span>
            }
            else if (desc.template) {
                const { $index, column, row } = body;

                return <span>{eval('`' + desc.template + '`')}</span>
            }
            else if (desc.map) {
                if (body.row[desc.prop] in desc.map) {
                    let { color, text } = desc.map[body.row[desc.prop]];

                    return <span style={'color:' + color}>{text}</span>
                }
                else if (desc.map.default) {
                    let { color, text } = desc.map.default;

                    return <span style={'color:' + color}>{text}</span>
                }
                else {
                    return <span>{body.row[desc.prop]}</span>
                }
            }
        },
    }

    return <colDefiner {...{ scopedSlots }}></colDefiner>;
}